import BaseView from "scripts/views/baseView";
import MediaListView from "scripts/views/mediaListView";
import templateCategoriesPageListSubPage from "templates/categoriesPageListSubPage.hbs";

class CategoriesPageListSubPageView extends BaseView {
  get template() {
    return templateCategoriesPageListSubPage;
  }

  constructor(options) {
    super(options);

    this.mediaListView = this.addSubView(
      new MediaListView({
        collection: this.collection,
      }),
    );
  }

  render() {
    this.$el.html(this.template());

    this.mediaListView
      .appendTo($("#bb-categories-page-list-sub-page-list-view-region"))
      .render();

    return this;
  }

  sync() {
    return this.mediaListView.fetch();
  }
}

export default CategoriesPageListSubPageView;
